import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { LocalStorageService } from './storage/local-storage.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class KucoinService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private localStorage: LocalStorageService
  ) {}

  isKucoin() {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('kucoin');
  }
}
